import { theme as themeAntd } from 'antd'
import { useEffect, useState } from 'react'
import { ThemeAdmin } from '../themes/theme.admin'
import { ThemeConsumer } from '../themes/theme.consumer'
import { ThemeDark } from '../themes/theme.dark'
import { ThemeLight } from '../themes/theme.light'

const { useToken } = themeAntd

export type Theme = 'light' | 'dark' | 'consumer' | 'admin'

export const useTheme = () => {
  const [themeKey, setTheme] = useState<Theme>()

  const themeByKey = {
    light: ThemeLight,
    dark: ThemeDark,
    consumer: ThemeConsumer,
    admin: ThemeAdmin,
  }

  const theme = themeByKey[themeKey] ?? themeByKey.light

  useEffect(() => {
    const themeDefault = 'consumer'
    const themeSaved = localStorage.getItem('DESIGN_SYSTEM__THEME') as Theme
    setTheme(themeSaved ?? themeDefault)
  }, [])

  useEffect(() => {
    if (themeKey) {
      localStorage.setItem('DESIGN_SYSTEM__THEME', themeKey)
    }
  }, [themeKey])

  useEffect(() => {
    const extra = theme?.extra ?? {}

    for (const [key, value] of Object.entries(extra)) {
      if (value) {
        document.documentElement.style.setProperty(`--${key}`, value)
      } else {
        document.documentElement.style.removeProperty(`--${key}`)
      }
    }
  }, [theme])

  return { themeKey, theme, setTheme, useToken }
}

export const ThemeSetter = ({ children }) => {
  const { token } = useToken()

  useEffect(() => {
    document.documentElement.style.backgroundColor = token.colorBgBase
    document.documentElement.style.color = token.colorTextBase

    return () => {
      document.documentElement.style.removeProperty('--scrollbar-thumb')
      document.documentElement.style.backgroundColor = ''
      document.documentElement.style.color = ''
    }
  }, [token])

  return children
}
